import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Speech from '../../SpeechLib/Speech';


import './SpeechDisplayer.css';


const SpeechDisplayer = ( { character, onClick } ) => {
  const canvasRef = useRef(null)
  const ctxref = useRef(null)

  function update(buffer, width, height) {
    canvasRef.current.width = width
    canvasRef.current.height = height
    ctxref.current.putImageData(new ImageData(new Uint8ClampedArray(buffer), width, height), 0, 0);
  }

  useEffect(() => {
    ctxref.current = canvasRef.current.getContext('2d')

    character.registerUpdate(update)
  }, [])


  return (
    <div className={"SpeechDisplayer" + (Speech.dialogs.currentDial ? " visible" : "")} >
      <canvas className="character" id="character" ref={canvasRef}></canvas>
    </div>
  );
};

export default observer(SpeechDisplayer)
